export default __webpack_public_path__ + "static/media/vuilniscontainers.109cc94a.svg";